import { createStructuredSelector } from 'reselect';
import { areImagesBeingDownloaded } from 'containers/App/selectors';
import { activeArtboard } from 'containers/Artboards/selectors';
import { projectFlatColors } from 'containers/BrandDefinition/selectors';
import { imagesForAssetsPanel } from 'containers/Documents/selectors';
import { extendedScreenSections, orderedActiveLayoutsBySectionId } from 'containers/Layouts/selectors';
import { screenWidth, sectionsHeight, sectionsWidthByName } from 'containers/ScreenDefinitions/selectors';

export const artboardContainerSelector = createStructuredSelector({
  areImagesBeingDownloaded,
  artboard: activeArtboard,
  colors: projectFlatColors,
  images: imagesForAssetsPanel,
  layoutsBySectionId: orderedActiveLayoutsBySectionId,
  sections: extendedScreenSections,
  sectionsHeight,
  sectionsWidth: sectionsWidthByName,
  width: screenWidth,
});
